<template>
  <v-app id="inspire">
    <v-navigation-drawer class="side-menu" v-model="drawer" clipped fixed app>
      <v-list>
        <r-link linkname="main"></r-link>
        <r-link linkname="liver"></r-link>
        <d-link linkname="公式サイト" color="#449956" href="http://nijisanji.ichikara.co.jp/"></d-link>
        <d-link linkname="非公式Wiki" color="#F1E953" href="https://wikiwiki.jp/nijisanji/"></d-link>
        <d-link linkname="ボイス販売" color="#E17F30" href="https://nijisanji.booth.pm/"></d-link>
        <d-link linkname="pixivFANBOX" color="#CA2D35" href="https://www.pixiv.net/fanbox/creator/24113985"></d-link>
        <d-link linkname="二次創作ガイドライン" color="#314B6E" href="https://www.ichikara.co.jp/fanart"></d-link>
        <r-link linkname="youtube_names"></r-link>
        <r-link linkname="settings"></r-link>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar color="#314B6E" dark fixed app clipped-left>
      <v-btn text icon @click.stop="drawer = !drawer">
        <v-icon>menu</v-icon>
      </v-btn>
      <v-toolbar-title>にじなんじ？</v-toolbar-title>
    </v-app-bar>
    <v-content>
      <v-layout>
        <v-fade-transition mode="out-in">
          <router-view></router-view>
        </v-fade-transition>
      </v-layout>
    </v-content>
  </v-app>
</template>

<style type="css">
  .v-navigation-drawer {
    width: 200px !important;
    background-color: #314B6E !important;
  }
  .v-list {
    padding: 0px;
  }
</style>

<script>
import ls from './util/local_storage.js';
import api from './util/api.js';

export default {
  name: 'app',
  data: () => ({
    drawer: false
  }),

  created() {
  },

  mounted() {
    if("Notification" in window) {
      let permission = window.permission;
      if(permission == "granted" || permission == "denied") {
        return;
      }
      Notification.requestPermission();
    }
    api.get('livers/').then(res => {
      this.$store.commit('setLivers', res.data);
      return ls.get('favoriteLivers');
    }).then(res => {
      this.$store.commit('setFavoriteLivers', res || []);
      return ls.get('notifyMinutes');
    }).then(res => {
      this.$store.commit('setNotifyMinutes', res || 10);
      return ls.get('canReload');
    }).then(res => {
      this.$store.commit('setCanReload', res || false);
      return ls.get('reloadMinutes');
    }).then(res => {
      this.$store.commit('setReloadMinutes', res || 60);
    }).catch(console.log);
  },

  methods: {
  }
}
</script>
